import { useQuery } from '@tanstack/react-query';
import { useSession } from '../auth/session';
import { ApercuGarde } from './ApercuGarde';
import type { Dossier } from '../dossier/types';

/**
 * Aperçu montré au parent qui vient de rejoindre.
 *
 * L'emplacement du parent est lu depuis l'API plutôt que supposé : deviner qui est qui
 * afficherait « chez vous » sur les périodes de l'autre, c'est-à-dire un calendrier faux
 * au moment précis où il faut inspirer confiance.
 */
export function ApercuArrivee({ caseFileId }: { caseFileId: string }) {
  const { client } = useSession();

  const dossier = useQuery({
    queryKey: ['case-file', caseFileId],
    queryFn: () => client.request<Dossier>(`/case-files/${caseFileId}`),
  });

  if (dossier.isPending) return <p className="discret">Chargement du calendrier…</p>;
  if (dossier.isError) return <p className="discret">Le calendrier sera visible depuis le dossier.</p>;

  const monSlot = dossier.data.parents.find((p) => p.isViewer)?.slot ?? null;
  return <ApercuGarde caseFileId={caseFileId} monSlot={monSlot} />;
}
